import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { Img } from "arv-reactcomponents";
import { LISTING, Endpoints } from "npmlinks-constants";

@inject("CommonStore")
@observer
class SizeNudgeBlock extends Component {
  render() {
    const { isDesktop } = this.props.CommonStore;

    return (
      <div className={isDesktop && "nw-sizenudgeblock-isdesktop" || "nw-sizenudgeblock-ismobile"}>
        <Img className="nw-sizenudgeblock-image" src={isDesktop ? Endpoints.SIZE_NUDGE_INFO_LOGO.desktop : Endpoints.SIZE_NUDGE_INFO_LOGO.mobile} alt="info-logo" />
        <span className="nw-sizenudgeblock-text">{LISTING.SIZENUDGEBLOCK_TEXT}</span>
      </div>
    );
  }
};

SizeNudgeBlock.wrappedComponent.propTypes = {
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: SizeNudgeBlock.wrappedComponent,
  component: SizeNudgeBlock,
};

export default ProjectComponent;
